import { NgRedux } from "@angular-redux/store";
import { Injectable } from "@angular/core";
import { IsicCardActivation, RidangoReduxAction } from "@ridango/core";
import { IsicCardActions } from "./isic-card.actions";
import { IsicCardPartialStoreState } from "./isic-card.reducer";
import * as IsicCardSelectors from './isic-card.selectors';

@Injectable({
    providedIn: 'root'
})
export class IsicCardFacade {
    isIsicCardActivationFinished$ = this.store.select(IsicCardSelectors.getIsicCardActivationFinished);
    error$ = this.store.select(IsicCardSelectors.getError);
    isIsicCardLoading$ = this.store.select(IsicCardSelectors.getIsicCardActivationLoading);

    constructor(private store: NgRedux<IsicCardPartialStoreState>, private actions: IsicCardActions) {}

    dispatch(action: RidangoReduxAction) {
        this.store.dispatch(action);
    }

    activateIsicCard(payload: IsicCardActivation) {
        this.dispatch(this.actions.activateIsicCard(payload));
    }

    setIsicCardLoading(loading: boolean) {
        this.dispatch(this.actions.setIsicCardActivationLoading(loading));
    }
}